export default __webpack_public_path__ + "3e9af4cdecf02e1448d74140fc3d64ec.svg";